<template>
  <ModalDialog
    ref="dialog"
    title="Panel Successfully Recut"
    icon="fa-check-circle"
    :showFooter="true"
    :scrollable="false"
    :showSubmit="false"
    @closed="onClosed">

    <div>
      <h2>New Panel Details</h2>
      <FormRow label="Barcode">
        <FormStaticLabel>{{panelData.barcode}}</FormStaticLabel>
      </FormRow>
      <div class="row">
        <div class="col-3">
          <FormButton 
            v-if="displayPrintLabel"
            :loading="printingLabel"
            @click="printLabelClicked"
            class="btn btn-success btn-block">
            <i class="far fa-print"></i><br />Print Label
          </FormButton>

          <div v-if="labelPrinted" class="mt-2">
            <Icon icon="fa-check-circle" class="result-fg-success" /> <strong>Label Printed</strong>
          </div>
          <div v-if="labelPrintError" class="mt-2">
            <Icon icon="fa-times-circle" class="result-fg-failed" /> <strong>Error {{labelPrintError}}</strong>
          </div>
        </div>
      </div>
    </div>
    
  </ModalDialog>
</template>

<script>
import _ from 'lodash'
import ModalDialog from '@/components/modalDialog.vue'
import modalDialog from '@/mixins/modalDialog'

export default {
  name: 'RecutPanelResultDialog',
  mixins: [
    modalDialog
  ],
  components: {
    ModalDialog
  },
  props: {
    panelData: Object,
    displayPrintLabel: Boolean
  },
  data() {
    return {
      labelPrinted: false,
      printingLabel: false,
      labelPrintError: ''
    }
  },
  created() {
  },
  mounted() {
  },
  computed: {
    
  },
  methods: {
    show() {
      return modalDialog.methods.show.call(this, arguments)
    },
    onClosed() {
      this.modalClosed(null)
    },
    printLabelClicked() {
      var labelURL = `/production/panels/labels`
      var printParams = { download: true, label: true, panelIDList: [this.panelData.id] }

      this.printingLabel = true

      var params = $.param(printParams)
      this.$apiService.reportingService.generateReportSignedURL(`${labelURL}?${params}`)
      .then(response => {
        window.location.href = response.data.url

        this.labelPrinted = true
      })
      .catch(err => {
        this.labelPrintError = 'Error printing label'
      })
      .finally(() => {
        this.printingLabel = false
      })      
    }
  }
}
</script>